<div class="tile-wrapper">
  <img ngSrc="assets/images/icons/bulb-icon.svg" alt="bulb-icon" height="87" width="65"/>
  <h2>Add a Project</h2>
  <p>Click this tile to begin</p>
</div>
